<template>
	<div :class="`relative ${full ? 'w-full grow' : 'w-fit'}`">
		<a :class="`${full ? 'w-full' : 'w-fit'}`" @click.stop="toggleDropdown(id)">
			<slot name="button"/>
		</a>
		<DropdownContainer :id="id" :right="right">
			<slot/>
		</DropdownContainer>
	</div>
</template>
<script setup lang="ts">
import {ref, defineProps} from 'vue'
import {toggleDropdown} from '@/helpers'
import DropdownContainer from '@/Components/Dropdown/DropdownContainer.vue'

const props = defineProps({
	id: {
		type: String,
		required: true,
	},
	full: Boolean,
	right: Boolean,
})

const id = ref(props.id)
const right = ref(props.right)
</script>